import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useCallback } from 'react';

import { useMutation } from '#src/hooks/graphql/useMutation.ts';

import type {
  CreateEphemeralLink,
  CreateEphemeralLinkVariables,
} from './__generated__/useEphemeralLink.graphql.ts';

const CREATE_EPHEMERAL_LINK_MUTATION = gql`
  mutation CreateEphemeralLink($input: createEphemeralLinkInput!) {
    createEphemeralLink(input: $input) {
      url
      errors {
        message
      }
    }
  }
` as TypedDocumentNode<CreateEphemeralLink, CreateEphemeralLinkVariables>;

export const useEphemeralLink = () => {
  const [mutate] = useMutation(CREATE_EPHEMERAL_LINK_MUTATION);

  return useCallback(
    async (url: string) => {
      const res = await mutate({
        variables: { input: { url, tokenAsQueryParam: true } },
      });

      return res.data?.createEphemeralLink?.url;
    },
    [mutate]
  );
};
